import { render, staticRenderFns } from "./TrackingCodeConfirm.vue?vue&type=template&id=6a64fc3a&scoped=true"
import script from "./TrackingCodeConfirm.vue?vue&type=script&lang=js"
export * from "./TrackingCodeConfirm.vue?vue&type=script&lang=js"
import style0 from "./TrackingCodeConfirm.vue?vue&type=style&index=0&id=6a64fc3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a64fc3a",
  null
  
)

export default component.exports